import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MapPinIcon, ClockIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-schwarz text-gray-light py-20 border-t border-gray-800" data-id="element-61">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-62">
        {/* Brand */}
        <div data-id="element-63">
          <Link to="/" className="mb-8 block" data-id="element-64">
            <img src="https://cdn.magicpatterns.com/uploads/5ai4To1omyuTFdS9ff8Uei/sekundarlogo.png" alt="edel & weiss Logo" className="h-12 w-auto object-contain" data-id="element-65" />
          </Link>
          <p className="text-gray-medium text-sm font-lora leading-relaxed mb-6" data-id="element-66">
            Ihre Praxis für ganzheitliche Zahnmedizin im Herzen der Stadt
            Nürnberg. Spezialisiert, interdisziplinär und zukunftsweisend.
          </p>
        </div>

        {/* Quick Links */}
        <div data-id="element-67">
          <h4 className="text-weiss font-poppins font-bold text-lg mb-6 uppercase tracking-widest" data-id="element-68">
            Navigation
          </h4>
          <ul className="space-y-3 text-sm font-lora" data-id="element-69">
            <li data-id="element-70">
              <Link to="/leistungen" className="hover:text-gold transition-colors" data-id="element-71">
                Leistungen
              </Link>
            </li>
            <li data-id="element-72">
              <Link to="/kieferorthopaedie" className="hover:text-gold transition-colors" data-id="element-73">
                Kieferorthopädie
              </Link>
            </li>
            <li data-id="element-74">
              <Link to="/oralchirurgie" className="hover:text-gold transition-colors" data-id="element-75">
                Oralchirurgie
              </Link>
            </li>
            <li data-id="element-76">
              <Link to="/team" className="hover:text-gold transition-colors" data-id="element-77">
                Team
              </Link>
            </li>
            <li data-id="element-78">
              <Link to="/karriere" className="hover:text-gold transition-colors" data-id="element-79">
                Karriere
              </Link>
            </li>
            <li data-id="element-80">
              <Link to="/blog" className="hover:text-gold transition-colors" data-id="element-81">
                Blog
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div data-id="element-82">
          <h4 className="text-weiss font-poppins font-bold text-lg mb-6 uppercase tracking-widest" data-id="element-83">
            Kontakt
          </h4>
          <ul className="space-y-4 text-sm font-lora" data-id="element-84">
            <li className="flex items-start space-x-3" data-id="element-85">
              <MapPinIcon className="w-5 h-5 text-gold shrink-0" data-id="element-86" />
              <span data-id="element-87">
                Musterstraße 123
                <br data-id="element-88" />
                90402 Nürnberg
              </span>
            </li>
            <li className="flex items-center space-x-3" data-id="element-89">
              <PhoneIcon className="w-5 h-5 text-gold shrink-0" data-id="element-90" />
              <a href="tel:091156836360" className="hover:text-weiss transition-colors" data-id="element-91">
                0911-56 83 63 60
              </a>
            </li>
            <li className="flex items-center space-x-3" data-id="element-92">
              <MailIcon className="w-5 h-5 text-gold shrink-0" data-id="element-93" />
              <a href="mailto:info@edel-und-weiss.de" className="hover:text-weiss transition-colors" data-id="element-94">
                info@edel-und-weiss.de
              </a>
            </li>
          </ul>
        </div>

        {/* Hours */}
        <div data-id="element-95">
          <h4 className="text-weiss font-poppins font-bold text-lg mb-6 uppercase tracking-widest" data-id="element-96">
            Öffnungszeiten
          </h4>
          <ul className="space-y-3 text-sm font-lora" data-id="element-97">
            <li className="flex justify-between" data-id="element-98">
              <span data-id="element-99">Mo - Do</span>
              <span data-id="element-100">08:00 - 20:00</span>
            </li>
            <li className="flex justify-between" data-id="element-101">
              <span data-id="element-102">Freitag</span>
              <span data-id="element-103">08:00 - 20:00</span>
            </li>
            <li className="flex justify-between text-gold font-bold" data-id="element-104">
              <span data-id="element-105">Samstag</span>
              <span data-id="element-106">08:00 - 14:00</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-16 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-xs font-poppins text-gray-medium" data-id="element-107">
        <p data-id="element-108">
          &copy; {new Date().getFullYear()} edel & weiss Zahnarztpraxis
          Nürnberg. Alle Rechte vorbehalten.
        </p>
        <div className="flex space-x-6 mt-4 md:mt-0 uppercase tracking-widest" data-id="element-109">
          <Link to="/impressum" className="hover:text-weiss transition-colors" data-id="element-110">
            Impressum
          </Link>
          <Link to="/datenschutz" className="hover:text-weiss transition-colors" data-id="element-111">
            Datenschutz
          </Link>
        </div>
      </div>
    </footer>;
}